import { ElementType, JSX } from "react";

const DEFAULT_ELEMENT = "div";

type DefaultElementType = typeof DEFAULT_ELEMENT;

type IntrinsicElements = JSX.IntrinsicElements;

type InferComponentType<T> = T extends keyof IntrinsicElements
  ? T
  : DefaultElementType;

export type ComponentAsProps<T extends ElementType> = {
  as?: ElementType<
    IntrinsicElements[InferComponentType<T>],
    InferComponentType<T>
  >;
} & IntrinsicElements[InferComponentType<T>];

/**
 * ComponentAs renders as the given HTML element, or as 'div' by default.
 */
const ComponentAs = <T extends ElementType>({
  as,
  children,
  ...rest
}: ComponentAsProps<T>) => {
  const Component = as ?? (DEFAULT_ELEMENT as T);

  return <Component {...rest}>{children}</Component>;
};

export default ComponentAs;
